import { axios } from '@/lib/axios'
import { useQuery } from '@tanstack/react-query'
import { Category } from '../types'

const getCategories = async (): Promise<Category[]> => {
  const response: Category[] = await axios.get('/category')
  response.unshift({ _id: '', name: 'All' })
  return response
}

export const useCategories = () => {
  return useQuery({
    queryKey: ['categories'],
    queryFn: getCategories,
  })
}
